<template>
  <section class="row">
    <div class="col-12">
      <h2 class="text-blue-700">
        Parrainer des amis
        <font-awesome-icon
          icon="question-circle"
          class="cursor-pointer "
          @click="$router.push('/client/perks/sponsorship/how-it-works')"
        />
      </h2>
      <!-- description   -->
      <p class="my-2">
        Invitez vos amis à souscrire chez Assurup et gagnez <span>10 € chacun</span> . <br>
        Faites progresser votre cagnotte : vous et votre filleul serez crédités de 10 € à chaque souscription .
      </p>
    </div>
    <div class="col-12">
      <sponsorship-invite-form />
    </div>
  </section>
</template>
<script>
import { ui } from '@/mixins';
import getShortUrl from '@/services/vendors/tinyurl';
import SponsorshipInviteForm from './SponsorshipInviteForm.vue';

export default {
  name: 'SponsorshipInvite',
  components: {
    SponsorshipInviteForm,
  },
  mixins: [ui],
  data() {
    return {
      shortUrl: '',
    };
  },
  computed: {
    credentials() {
      return this.$store.getters['client/clientCredentials'];
    },
    clientId() {
      if (this.credentials) {
        return this.credentials.clientId;
      }
      return null;
    },
  },
  watch: {
    clientId: {
      handler(value) { this.buildShortUrl(value) },
    },
  },
  mounted() {
    if (this.clientId) {
      this.buildShortUrl(this.clientId);
    }
  },
  methods: {
    clipboardCopy() {
      const copyText = document.getElementById('shadowInvitePromo');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.ui_showToast({ show: true, message: 'Lien de parrainage copié !' });
    },
    buildShortUrl(value) {
      const host = import.meta.env.VITE_MODE === 'production' ? 'https://app.assurup.com' : 'http://pprod.app.assurup.com';
      const url = `${host}/sponsorship?id=${value}`;
      getShortUrl(url).then(({ data }) => { this.shortUrl = data });
    },
    openFacebookDialog() {
      this.$store.dispatch('facebook/shareLink', { link: this.shortUrl, redirectUri: 'www.assurup.com/client' });
    },
  },
};
</script>


<style scoped>
p span {
  font-weight: 600;
}
</style>
